import React, { useEffect, useState } from 'react'
import { Header } from '../../calendar/components'
import DateRange from '../../calendar/entities/date-range'
import { getPlanAheadPricing } from '../helpers/calendar'
import { DateTime } from 'luxon'
import DateLogic from '../../calendar/helpers/date-logic'
import ListViewDisplay from './list-view-display'
import storage from '../../services/storage'

// this ListView uses a start and end date to make it's own weekly calls to get planningInfo
const ListView = ({
  onDayClick,
  loadingCalendar,
  setLoading,
  calendarStartDate,
  setCalendarStartDate,
  planningInfo,
  setPlanningInfo,
  storageDateTime,
  TEST_JS_DATE,
  setError,
  selectDay,
  hours,
  selectedDate,
  priceTableInfo,
  setPriceTableInfo,
  isMobiDisplayed,
  showModal
}) => {
  // activeWeek is what dates are displayed
  // this is needed for the first onLoad because the api doesn't return past dates
  // also needed in case general addmision is sold out, if that happens the date won't be in disabledDates and it won't have planningInfo
  const [activeWeek, setActiveWeek] = useState([])
  // dateRange is used for navigating the calendar
  const [dateRange, setDateRange] = useState({})
  //clickedElement is used to set styling for selected elements and to hide unselected open alerts
  const [clickedElement, setClickedElement] = useState()
  const [useStorageDateTime, setUseStorageDateTime] = useState(storageDateTime)
  const todaysDateTime = DateLogic.today.valueOf()

  // this only sets PlanningInfo because this !fromEvent call is not party picker first so it
  // doesn't need minimumAvailability
  const fetchPlanAheadListView = async (
    startDate,
    productId,
    minimumAvailability,
    endDate
  ) => {
    try {
      const { planningInfo } = await getPlanAheadPricing(
        startDate,
        productId,
        minimumAvailability,
        endDate
      )
      setPlanningInfo(planningInfo)
      setLoading(false)
    } catch (_error) {
      selectDay(null)
      storage.clear()
      setError(true)
    }
  }

  // this useEffect re-fires when calendarStartDate is set
  // the first onLoad is using the calendarStartDate from calendar.js (today or test driven server datetime)
  useEffect(() => {
    setLoading(true)

    const unformatedDays = DateLogic.getDaysInWeek(
      useStorageDateTime || calendarStartDate
    )
    setActiveWeek(unformatedDays)

    let firstDate = unformatedDays[0]
    let endDate = unformatedDays[unformatedDays.length - 1]

    // need to make sure that firstDate isn't in the past
    // if it isn't use that instead of calendarStartDate
    // this is for when selected date is near the begining of the month and the active week
    // straddles two months, like 5/30/22 to 6/4/22 and selected day = 6/4/22
    let compareDate = TEST_JS_DATE || todaysDateTime
    let navDate = firstDate.ts < compareDate ? calendarStartDate : firstDate

    fetchPlanAheadListView(navDate, null, null, endDate)

    setDateRange(new DateRange(firstDate, endDate))
  }, [calendarStartDate])

  const navigate = day => {
    // doesn't need onMonthChange because disabledDates are always in the past
    // make sure the param day isn't in the past
    let paramDay = DateTime.fromISO(day, { zone: 'America/Chicago' })
    let navDate = paramDay.ts < todaysDateTime ? DateLogic.today : paramDay
    // trigger the useEffect to make all the calls again for this next set of 7 days
    setUseStorageDateTime(null)
    setCalendarStartDate(navDate)
  }

  const mapActiveWeek = () => {
    let oneDay

    return activeWeek.map((dateTime, i) => {
      dateTime = DateTime.fromMillis(dateTime.ts, { zone: 'America/Chicago' })
      let unavailableDay = dateTime.ts < todaysDateTime

      if (!unavailableDay) {
        oneDay = planningInfo.find(obj => {
          return parseInt(obj['date'].slice(8, 10)) === dateTime.day
        })
      }

      return (
        <ListViewDisplay
          dateTime={dateTime}
          unavailableDay={unavailableDay}
          onDayClick={onDayClick}
          oneDay={oneDay}
          key={dateTime.ts}
          clickedElement={clickedElement}
          setClickedElement={setClickedElement}
          fromEvent={false}
          hours={hours}
          selectedDate={selectedDate}
          priceTableInfo={priceTableInfo}
          setPriceTableInfo={setPriceTableInfo}
          isMobiDisplayed={isMobiDisplayed}
          showModal={showModal}
        />
      )
    })
  }

  // dateRange needs to be present for Header to work
  let mobiDateRange = Object.keys(dateRange).length === 0
  let loading = loadingCalendar || mobiDateRange

  return (
    !loading && (
      <React.Fragment>
        <Header
          key="header"
          dateRange={dateRange}
          navigate={navigate}
          navigateRelative={navigate}
          children={false}
          fromTicketsApp={true}
        />

        {mapActiveWeek()}
      </React.Fragment>
    )
  )
}

export default ListView
